import React from "react";
import { AccreditationBigSection } from "@/.storyblok/types/319751/storyblok-components";
import Image from "next/image";
import { SbBlokData, storyblokEditable } from "@storyblok/react";

interface AccreditorProps {
  blok?: AccreditationBigSection & SbBlokData;
}

const AccreditorsComponent: React.FC<AccreditorProps> = ({ blok }) => {
  const headline = blok?.headline || "Accreditations";
  const accreditations = blok?.accreditations || [];

  return (
    <div
      {...(blok && storyblokEditable(blok))}
      className="bg-white py-4 py-md-5"
    >
      <div className="container">
        <h3 className="lead-xl text-center text-primary mb-4">{headline}</h3>
        <div className="row footer-accreditations justify-content-center align-items-center g-3 g-sm-4">
          {accreditations.map((item) => (
            <div className="col-auto" key={item._uid}>
              <Image
                src={item.image?.filename || ""}
                alt={item.alt_image || "Accreditation"}
                title={item.alt_image || "Accreditation"}
                width={Number(item.width) || 120}
                height={Number(item.height) || 120}
                sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                loading="lazy"
                quality={75}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AccreditorsComponent;